import React, { Component } from "react";
import { DateRangePicker } from "react-dates";
import moment from "moment";

class DateRange extends Component {
  state = {
    startDate: this.props.startDate && this.props.startDate !== "" ? moment(this.props.startDate) : null,
    endDate: this.props.endDate && this.props.endDate !== "" ? moment(this.props.endDate) : null,
    focusedInput: null,
  };

  onDateChange = (dates) => {
    const { startDate, endDate } = dates;
    this.setState({ startDate: startDate, endDate: endDate }, () => {
      this.props.setDateFilter(startDate, endDate);
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.startDate !== prevProps.startDate && this.props.startDate === "") {
      this.setState({
        startDate: null,
        endDate: null,
      });
    }
  }

  render() {
    return (
      <DateRangePicker
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        onDatesChange={this.onDateChange}
        focusedInput={this.state.focusedInput}
        onFocusChange={(focusedInput) => this.setState({ focusedInput: focusedInput })}
        showDefaultInputIcon
        small={true}
        showClearDates
        isOutsideRange={() => false}
        startDateId="MyDatePicker"
        endDateId="MyDatePicker"
      />
    );
  }
}

export default DateRange;
